import { isMaxResource } from '@/helpers/resourceTypes'

const defaultSegmentations = () => ({ include: [], exclude: [] })

const defaultSettings = {
    id: null,
    status: null,
    type: 'sendMessage',
    // Платформа доставки (tasks.platform). Приходит с сервера, задать нельзя — она
    // определяется ресурсом. Конструктор сообщения выбирается по типу ресурса (см. _msg.vue),
    // а не по этому полю: у новой, ещё не сохранённой рассылки его просто нет.
    platform: null,
    name: '',
    bot_key: null,
    segmentations: defaultSegmentations(),
    message: {},
    settings: {
        intervalCap: 10,
        rateLimitOnError: {
            stop: true,
            extraDelay: 0
        },
        filter_active_only: false
    },
    date_send: null,
    parent_id: null,
    parent: null,
    children_stats: null,
    recurrence_rule: null,
    recurrence_next_at: null,
    stat_left_users_1: null,
    stat_left_users_2: null,
    stat_left_users_3: null,
    stat_avg_time_left: null
    // statistics: null
    // statistics: {
    //     left_users_1: 10,
    //     left_users_2: 30,
    //     left_users_3: 30,
    //     avg_time_left: 500
    // }
}

const STATUS_DRAFT = 0;
// const STATUS_NOT_STARTED= 1;
// const STATUS_IN_PROGRESS = 2;
// const STATUS_DONE = 3;
// const STATUS_CANCEL = 4;
// const STATUS_ERROR = 5;
// const STATUS_PREPARING_LIST = 6;
const STATUS_RECURRING_TEMPLATE = 10;
const STATUS_RECURRING_PAUSED = 11;
const STATUS_RECURRING_PAYMENT_REQUIRED = 12;
//
// const DATA_STATUS_WAIT_SEND = 0;
// const DATA_STATUS_IN_PROGRESS = 1;
// const DATA_STATUS_DONE = 2;
// const DATA_STATUS_CANCEL = 3;
// const DATA_STATUS_ERROR = 3;
// const DATA_STATUS_LOAD_FOR_SEND = 5;

// const newBotSetting = JSON.parse(localStorage.getItem(nameVariableForLS));

export default {
    namespaced: true,
    state: { ...defaultSettings }, // newBotSetting ??
    actions: {
    },
    getters: {
        editMode: function(state) {
            if (state.status === null || state.status === STATUS_DRAFT
                || state.status === STATUS_RECURRING_TEMPLATE || state.status === STATUS_RECURRING_PAUSED
                || state.status === STATUS_RECURRING_PAYMENT_REQUIRED) {
                return true
            }
            return false
        },
        caption: function(state) {
            return state.status.message?.caption
        },
        // Ресурс рассылки — MAX-бот. Признак живёт здесь, а не в каждом шаге: по нему
        // ветвятся и _type, и _msg, и _send, и три копии одного и того же вычисления
        // разъехались бы при первой же правке. Резолвим через список ресурсов, а не через
        // state.platform: у ещё не сохранённой рассылки платформы нет.
        isMaxResource: function(state, getters, rootState) {
            const key = state.bot_key ?? rootState.init.current_bot?.key
            const bots = rootState.init.user_bots
            const list = Array.isArray(bots) ? bots : Object.values(bots ?? {})
            return isMaxResource(list.find(b => b.key === key))
        }
    },
    mutations: {
        /**
         * {name: 'properties', val: 'value'}
         * @param state
         * @param name
         * @param val
         * @private
         */
        __set(state, {name, val}) {
            state[name] = val
        },
        __setMessageOption(state, {name, val}) {
            if (state.message === null) {
                state.message = {}
            }
            state.message[name] = val
        },
        __setMessageButton(state, {name, val, editButton}) {
            if (name === 'web_app') {
                if (state.message.reply_markup.inline_keyboard[editButton[0]][editButton[1]].web_app === undefined) {
                    state.message.reply_markup.inline_keyboard[editButton[0]][editButton[1]].web_app = {url: val }
                } else {
                    state.message.reply_markup.inline_keyboard[editButton[0]][editButton[1]].web_app.url = val
                }
                return
            }
            state.message.reply_markup.inline_keyboard[editButton[0]][editButton[1]][name] = val
        },
        __setMessageCreateButton(state, {row, col, val}) {
            if (state.message.reply_markup === undefined) {
                state.message.reply_markup = {}
            }
            if (state.message.reply_markup.inline_keyboard === undefined) {
                state.message.reply_markup.inline_keyboard = []
            }
            if (row === null) {
                state.message.reply_markup.inline_keyboard.push([])
                row =  state.message.reply_markup.inline_keyboard.length - 1
            }
            if (col === null) {
                state.message.reply_markup.inline_keyboard[row].push([])
                col =  state.message.reply_markup.inline_keyboard[row].length - 1
            }
            state.message.reply_markup.inline_keyboard[row][col] = val
        },
        __setMessageDelButton(state, {row, col}) {
            state.message.reply_markup.inline_keyboard[row].splice(col)

            if (!state.message.reply_markup.inline_keyboard[row].length) {
                state.message.reply_markup.inline_keyboard.splice(row)
            }
        },
        __setSettings(state, {name, val}) {
            if (state.settings === null) {
                state.settings = {}
            }
            state.settings[name] = val
        },
        addSegmentItem(state, { group, item }) {
            if (!state.segmentations) state.segmentations = defaultSegmentations()
            if (!state.segmentations[group]) state.segmentations[group] = []
            state.segmentations[group].push(item)
        },
        removeSegmentItem(state, { group, index }) {
            if (!state.segmentations?.[group]) return
            state.segmentations[group].splice(index, 1)
        },
        updateSegmentItem(state, { group, index, config }) {
            if (!state.segmentations?.[group]?.[index]) return
            state.segmentations[group][index] = { ...state.segmentations[group][index], config }
        },
        resetData(state) {
            for (let i in state) {
                state[i] = i === 'segmentations' ? defaultSegmentations() : (defaultSettings[i] ?? null)
            }
        },
        loadData(state, data) {
            // Normalise / migrate segmentations to new { include, exclude } format
            const s = data.segmentations
            if (!s || Array.isArray(s)) {
                data.segmentations = defaultSegmentations()
            } else if (!s.include) {
                // Old format: { all?, filter?, custom?: [...] }
                const include = []
                if (s.all !== undefined) include.push({ type: 'all', config: {} })
                if (Array.isArray(s.custom)) {
                    s.custom.forEach(item => include.push({ type: 'custom', config: item }))
                }
                if (s.filter) include.push({ type: 'filter', config: s.filter })
                data.segmentations = { include, exclude: [] }
            } else if (!s.exclude) {
                s.exclude = []
            }

            if (data.message === null) {
                data.message = {}
            }
            if (Array.isArray(data.message)) {
                data.message = {}
            }

            for (let i in data) {
                state[i] = data[i]
            }
        }
    }

}

